export default {
  'system.dict.data.title': '字典数据',
  'system.dict.data.dict_code': '字典编码',
  'system.dict.data.dict_sort': '字典排序',
  'system.dict.data.dict_label': '字典标签',
  'system.dict.data.dict_value': '字典键值',
  'system.dict.data.dict_type': '字典类型',
  'system.dict.data.css_class': '样式属性',
  'system.dict.data.list_class': '回显样式',
  'system.dict.data.is_default': '是否默认',
  'system.dict.data.status': '状态',
  'system.dict.data.create_by': '创建者',
  'system.dict.data.create_time': '创建时间',
  'system.dict.data.update_by': '更新者',
  'system.dict.data.update_time': '更新时间',
  'system.dict.data.remark': '备注',
};
